import { getEndpoint } from "@api-routes/endpoint";

const BARRINGS_MS_NAME = "eir-barrings";
export const getBarringRoute = (serviceId: number) => `${getEndpoint(BARRINGS_MS_NAME)}barring/${serviceId}`;
